import { Moment } from 'moment';
import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';
import moment from 'moment-timezone';

export class StripeRefund
{
    id: number;
    stripeRefundId: string;
    paymentAttemptId: number;
    transactionId: number;
    amount: number;
    createdAt: Moment;

    constructor(refund: any) {
        this.id = refund.id || null;
        this.stripeRefundId = refund.stripeRefundId ?? refund.stripe_refund_id ?? null;
        this.paymentAttemptId = refund.paymentAttemptId ?? refund.payment_attempt_id ?? null;
        this.transactionId = refund.transactionId ?? refund.transaction_id ?? null;
        this.amount = refund.amount ?? null;

        const timezone = LegFiJwtService.getTimezone();
        const createdAtRaw = refund.createdAt ?? refund.created_at;
        if (createdAtRaw) {
            this.createdAt = moment.utc(createdAtRaw, 'YYYY-MM-DD HH:mm:ss').tz(timezone);
        }
    }
}
